import * as React from "react"
import { Box, Typography } from "@mui/material"
import StreamingCamera from "../components/streaming/StreamingCamera"

export default function Stream() {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3">Live Stream</Typography>
        <Typography variant="subtitle1">
          Real-time climb detection from your camera feed
        </Typography>
      </Box>
      <StreamingCamera />
    </Box>
  )
}
